import React, { useState } from 'react';
import { StepHelpButton, StepHelpDialog } from '../zap-automations/ig-dm-automations/wizard/StepHelp';
import FeatureGuideModal from './FeatureGuideModal';
import { FeatureGuide, stepHelpFromGuide } from './guideContent';

/* The Zap wizard's ⓘ help, for the Storefront and Link in Bio setup wizards.
   Returns the button (for next to "Step X of 4") and the dialogs (render them
   anywhere in the wizard — both portal to the body). These wizards are plain
   page content, not a dialog, so the full guide can be the usual MUI modal. */
export default function useWizardStepHelp(guide: FeatureGuide, stepIndex: number, seenKey: string) {
  const [open, setOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  // Pulses until the creator has opened help once (remembered in this browser).
  const [seen, setSeen] = useState(() => {
    try { return localStorage.getItem(seenKey) === 'true'; } catch { return true; }
  });

  const help = stepHelpFromGuide(guide, stepIndex);

  const onClick = () => {
    setOpen(true);
    if (!seen) {
      setSeen(true);
      try { localStorage.setItem(seenKey, 'true'); } catch { /* private mode: pulse again next time */ }
    }
  };

  const helpButton = help ? <StepHelpButton onClick={onClick} pulse={!seen} /> : null;

  const helpOverlay = (
    <>
      {help && (
        <StepHelpDialog
          open={open}
          onOpenChange={setOpen}
          kicker={help.kicker}
          content={help.content}
          onOpenGuide={() => {
            setOpen(false);
            setGuideOpen(true);
          }}
        />
      )}
      <FeatureGuideModal open={guideOpen} onClose={() => setGuideOpen(false)} guide={guide} />
    </>
  );

  return { helpButton, helpOverlay };
}
